import { Listing, ListingType } from '../../../../../../../models/Listing';
import { createContext } from 'react';
import utils from 'utils';

type ListingContextProps = {
  listing: Listing;
  listingFormValues: Partial<Listing>;
  listingType: ListingType;
  patchListing: (listing: Listing) => Promise<void>;
  setListing: React.Dispatch<React.SetStateAction<Listing>>;
};

export default createContext<Partial<ListingContextProps>>({
  listing: null,
  listingFormValues: null,
  listingType: null,
  patchListing: utils.noop,
  setListing: utils.noop,
});
